import {
  HeadAgreementsByCustomerQuery,
  HeadAgreementsByCustomerQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { sortBy } from "lodash";

const query = gql`
  fragment AllHeadAgreementsByCustomer on HeadAgreement {
    id
    name
    statusCode
    headAgreementNumber
    valid {
      start {
        isoString
      }
      end {
        isoString
      }
    }
  }
  query HeadAgreementsByCustomer($customerId: ID!) {
    productPrice {
      customers {
        byId(id: $customerId) {
          id
          allHeadAgreements {
            ...AllHeadAgreementsByCustomer
          }
        }
      }
    }
  }
`;

export const useHeadAgreementsByCustomer = (customerId: string) => {
  const { data, error, loading } = useQuery<
    HeadAgreementsByCustomerQuery,
    HeadAgreementsByCustomerQueryVariables
  >(query, { variables: { customerId }, fetchPolicy: "network-only" });

  const headAgreements =
    data?.productPrice.customers.byId?.allHeadAgreements ?? [];
  const defaultHeadAgreement = headAgreements
    ? sortBy(headAgreements, "valid.start.isoString").reverse()[0]
    : null;

  return {
    headAgreements,
    defaultHeadAgreement,
    error,
    loading,
  };
};
